import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

export type CaseAssignmentEmailKind = 'proposed' | 'assigned';

/** Fire-and-forget: assignment UI must not fail if mail is down. */
export function requestCaseAssignmentEmail(
  caseId: string,
  counselorId: string | undefined,
  kind: CaseAssignmentEmailKind
): void {
  if (!caseId || !counselorId) return;
  const fn = httpsCallable(functions, 'notifyCaseAssignment');
  void fn({ caseId, counselorId, kind }).catch((error) => {
    console.error('Case assignment email failed:', error);
  });
}

export function requestNewEventEmail(eventId: string): void {
  if (!eventId) return;
  const fn = httpsCallable(functions, 'notifyNewEvent');
  void fn({ eventId }).catch((error) => {
    console.error('New event email failed:', error);
  });
}

export function requestAccountCredentialsEmail(userId: string, password: string): void {
  if (!userId || !password) return;
  const fn = httpsCallable(functions, 'notifyAccountCredentials');
  void fn({ userId, password }).catch((error) => {
    console.error('Account credentials email failed:', error);
  });
}

/** Fire-and-forget: monthly report submit must not fail if mail is down. */
export function requestMonthlyReportSubmittedEmail(monthKey: string): void {
  if (!monthKey) return;
  const fn = httpsCallable(functions, 'notifyMonthlyReportSubmitted');
  void fn({ monthKey }).catch((error) => {
    console.error('Monthly report submitted email failed:', error);
  });
}

export type AttentionPushKind =
  | 'session_report'
  | 'consent'
  | 'proposal_accepted'
  | 'proposal_declined';

export function requestAttentionPush(input: {
  kind: AttentionPushKind;
  caseId?: string;
  targetUserId?: string | null;
}): void {
  const fn = httpsCallable(functions, 'notifyAttentionPush');
  void fn({
    kind: input.kind,
    caseId: input.caseId || '',
    targetUserId: input.targetUserId || '',
  })
    .then((result) => {
      // The callable resolves happily when it decided not to send; the reason is only in
      // `data`, so swallowing it here is what made a missing email look like a hard failure.
      console.info('[attention]', input.kind, result.data);
    })
    .catch((error) => {
      console.error('Attention push failed:', error);
    });
}
